import * as $ from 'jquery';
import 'datepicker';
import 'selectize';
import * as Cookies from 'js-cookie';
import {ibeStandaloneIframe} from './ibe-standalone-iframe';

export class bookingFormInfant {
	/**
	 * @function closeBtns
	 * event handler for close ibe button
	 * do .off().on() to re init handlers (only need to init once)
	 */
	closeBtns(): void {
		let $infantAlertContainer:any = $('#infant-alert--container');

		$infantAlertContainer.find('.ibe-cancel').off('click.close-infant').on('click.close-infant', function () {
			$.magnificPopup.close();
		});
	}

	/**
	 * @function submitBtns
	 * @param  {any} $instance [description]
	 */
	submitBtns($instance:any):void {
		let _self = this;

		let $infantAlertContainer:any = $('#infant-alert--container');

		// infant alert modal submit buttons
		let $singleInfantContinueBtn:any = $infantAlertContainer.find('.single-city--infantBtn');
		let $multiInfantContinueBtn:any = $infantAlertContainer.find('.multi-city--infantBtn');
		let $redeemInfantContinueBtn:any = $infantAlertContainer.find('.redemption--infantBtn');

		let $submitBtns:Array<any> = [$singleInfantContinueBtn, $multiInfantContinueBtn, $redeemInfantContinueBtn];

		// event handler on clicking submit buttons
		// do .off().on() to re init handlers (only need to init once)
		$submitBtns.map(($el:any) => {
			$el.off('click.open-infant').on('click.open-infant', function(){
				$.magnificPopup.close();
				let $targetIbe:any = $instance;
				let $tripType:string = $infantAlertContainer.find('input[name="tripflow"]').val();
				let $paymentMethod:string = $infantAlertContainer.find('input[name="payment_method"]').val();
				let $warningAccepted:any = $infantAlertContainer.find('input[name="infant_warning"]');
				$warningAccepted.val("accepted");

				// trigger click on relevant button based on payment method and triptype
				_self.triggerRelevantSubmitBtn($targetIbe, $tripType, $paymentMethod);
			});
		});
	}

	/**
	 * trigger click on relevant button based on payment method and triptype
	 * to submit form
	 * @param {string} $targetIbe      - ibe target to trigger click on
	 * @param {string} tripType      - trip type (single/multi_desk/mob)
	 * @param {string} paymentMethod - payment method (cash/miles)
	 */
	triggerRelevantSubmitBtn($targetIbe:any, tripType:string, paymentMethod:string): void {

		// ibe booking form submit buttons (for each submission type)
		let $singleTripSubmitBtn:any = $targetIbe.find('.single-city--bookflight');
		let $multiTripSubmitBtn:any = $targetIbe.find('.multi-city--bookflight');
		let $multiTripMobSubmitBtn:any = $targetIbe.find('.mobile-multi-city--bookflight');
		let $singleTripMobSubmitBtn:any = $targetIbe.find('.mobile-search-form-submit');
		let $singleTripRdmSubmitBtn:any = $targetIbe.find('.redemption-submit-btn-single');
		let $singleTripRdmMobSubmitBtn:any = $targetIbe.find('.redemption-submit-btn-single');

		if (tripType === 'single_desk') {
			if (paymentMethod === 'cash') {
				// console.log('single desk cash', $singleTripSubmitBtn);
				$singleTripSubmitBtn.trigger('click');
			} else if (paymentMethod === 'miles') {
				// console.log('single desk miles', $singleTripRdmSubmitBtn);
				$singleTripRdmSubmitBtn.trigger('click');
			}
		} else if (tripType === 'single_mob') {
			if (paymentMethod === 'cash') {
				// console.log('single mob cash', $singleTripMobSubmitBtn);
				$singleTripMobSubmitBtn.trigger('click');
			} else if (paymentMethod === 'miles') {
				// console.log('single mob miles', $singleTripRdmMobSubmitBtn);
				$singleTripRdmMobSubmitBtn.trigger('click');
			}
		} else if (tripType === 'multi_desk') {
			// console.log('multi desk cash', $multiTripSubmitBtn);
			$multiTripSubmitBtn.trigger('click');
		} else if (tripType === 'multi_mob') {
			// console.log('multi desk cash', $multiTripSubmitBtn);
			$multiTripMobSubmitBtn.trigger('click');
		}
	}

	/**
	 * @function toggleSubmitBtnDisplay
	 * toggle display of infant booking submit buttons based on current
	 * booking form instance
	 * @param instance - only needed to detect current instance submit btn
	 */
	toggleSubmitBtnDisplay(instance:any):void {
		let _self = this;

		let $instance = $(instance);
		let $infantAlertContainer:any = $('#infant-alert--container');

		// infant alert modal submit buttons
		let $singleInfantContinueBtn:any = $infantAlertContainer.find('.single-city--infantBtn');
		let $multiInfantContinueBtn:any = $infantAlertContainer.find('.multi-city--infantBtn');
		let $redeemInfantContinueBtn:any = $infantAlertContainer.find('.redemption--infantBtn');

		let $warningAcceptedWrap:any = $infantAlertContainer.find('input[name="infant_warning"]');
		let $tripTypeContainerLi:any = $instance.find('.trip-type--container li');

		$tripTypeContainerLi.addClass('cash');
		$warningAcceptedWrap.val('');
		$singleInfantContinueBtn.show();
		$multiInfantContinueBtn.hide();
		$redeemInfantContinueBtn.hide();

		$instance.find('input[value=cash]').on('click', function(){
			$tripTypeContainerLi.removeClass('miles');
			$tripTypeContainerLi.addClass('cash');
			$warningAcceptedWrap.val('');
			$singleInfantContinueBtn.show();
			$multiInfantContinueBtn.hide();
			$redeemInfantContinueBtn.hide();
		});

		$instance.find('.trip-type--container li').on('click', function(){
			let tripLink = $(this);
			if (tripLink.hasClass('cash')) {
				if (tripLink.hasClass('multiCityTrip')) {
					$warningAcceptedWrap.val('');
					$singleInfantContinueBtn.hide();
					$multiInfantContinueBtn.show();
					$redeemInfantContinueBtn.hide();
				} else {
					$warningAcceptedWrap.val('');
					$singleInfantContinueBtn.show();
					$multiInfantContinueBtn.hide();
					$redeemInfantContinueBtn.hide();
				}
			} else if (tripLink.hasClass('miles')) {
				$warningAcceptedWrap.val('');
				$singleInfantContinueBtn.hide();
				$multiInfantContinueBtn.hide();
				$redeemInfantContinueBtn.show();
			}
		});

		$instance.find('input[value=cash_miles], input[value=miles]').on('click', function(){
			$tripTypeContainerLi.removeClass('cash');
			$tripTypeContainerLi.addClass('miles');
			$warningAcceptedWrap.val('');
			$singleInfantContinueBtn.hide();
			$multiInfantContinueBtn.hide();
			$redeemInfantContinueBtn.show();
		});
	}
}
